import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'filterProducts',
  pure: false
})
@Injectable()
export class FilterProductsPipe implements PipeTransform {

  transform(products, args: any) {
    if (args == null) {
      return products;
    }
    return products.filter(item => {
      //console.log(item.short_description.toLowerCase());
      return item.short_description.toLowerCase().indexOf(args.toLowerCase()) !== -1
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-products.pipe.ts